// extracted by mini-css-extract-plugin
export default {"host":"style_host__AU4HD","content":"style_content__G7Joa"};